export default __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-9-6799cd8bf010d8d1706bd01ab695cb44.jpg";